import axios from "axios";
import { API_ZIPCODES_URL } from "../utils/constants";
import { handleServiceError } from "../utils/helpers";

const SEPOMEX_API_URL = "https://sepomex.icalialabs.com/api/v1";
const SEPOMEX_API_ZIP_CODES_URL = SEPOMEX_API_URL + "/zip_codes";

export const getNeighborhoodsByZipCode = async (zipCode: string) => {
    try {
        const response = await axios.get(
            `${SEPOMEX_API_ZIP_CODES_URL}?zip_code=${zipCode}`,
            {
                headers: {}
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};


export const getSettlementsByZipCode = async (zipCode: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.get(
            `${API_ZIPCODES_URL}/${zipCode}/settlements`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};